import { lazily } from '@mkmp/core'

const { UnAuth } = lazily(() => import('@/features/common'))

/**
 * 公共路由
 */
export default [
  {
    path: 'unauth',
    element: <UnAuth />,
    handle: {
      isPublic: true
    }
  }
]
